import React from 'react'
import {
    Container,
    ResultsContainer,
    Title,
    ResultsText,
    CardContainer,
    LotImageContainer,
    DataContainer,
    LotAddress,
    LotTitle,
    LotImagePlaceholder
} from './ListView.style'
import { useTranslation } from 'react-i18next'
import { CarpayLot } from '@customTypes/carpayLot.interface'

interface Props {
    lots: CarpayLot[]
    onLotClick: (lot: CarpayLot) => void
}

const ListView: React.FC<Props> = ({ lots, onLotClick }) => {
    const { t } = useTranslation()

    return (
        <Container>
            <Title>{t('carpay.notFound.search.resultsTitle')}</Title>
            <ResultsText>
                {lots.length} {t(`carpay.notFound.search.${lots.length === 1 ? 'result' : 'results'}`)}
            </ResultsText>
            <ResultsContainer>
                {lots.map((lot) => (
                    <CardContainer key={lot.lot_id} onClick={() => onLotClick(lot)}>
                        <LotImageContainer>
                            <LotImagePlaceholder className="wemolo-parking-ok" />
                        </LotImageContainer>
                        <DataContainer>
                            <LotTitle>{lot.name}</LotTitle>
                            {/* show lot address before comma and after, check if exists */}
                            {lot.address.split(',')[0] && <LotAddress>{lot.address.split(',')[0]},</LotAddress>}
                            {lot.address.split(',')[1] && <LotAddress>{lot.address.split(',')[1]}</LotAddress>}
                        </DataContainer>
                    </CardContainer>
                ))}
            </ResultsContainer>
        </Container>
    )
}

export default ListView
